export const SET_CONFIGURATOR = 'SET_CONFIGURATOR'
export const RESET_CONFIGURATOR = 'RESET_CONFIGURATOR'

export const setConfigurator = configurator => ({
  type: SET_CONFIGURATOR,
  configurator
})

export const resetConfigurator = () => ({
  type: RESET_CONFIGURATOR
})
